<div class="page-container">
  <div class="dashboard-header">
    <h1>Dashboard</h1>
    <p class="dashboard-subtitle">Welcome to Youtopia Admin. Here's an overview of your system.</p>
  </div>

  @if (error() && !loading()) {
    <div class="error-state">
      <div class="error-content">
        <i class="pi pi-exclamation-triangle error-icon"></i>
        <h3>Unable to load dashboard data</h3>
        <p>There was an error loading the dashboard information. Please try again.</p>
        <p-button label="Retry" icon="pi pi-refresh" (onClick)="refresh()"></p-button>
      </div>
    </div>
  }
  @if (loading()) {
    <div class="loading-state">
      <div class="kpi-grid">
        <app-kpi-card
          title="Pending Healthy Gourmet Kitchens"
          icon="pi pi-users"
          color="primary"
          [value]="null"
          [loading]="true"
        ></app-kpi-card>
        <app-kpi-card
          title="Active Healthy Gourmet Kitchens"
          icon="pi pi-clock"
          color="warning"
          [value]="null"
          [loading]="true"
        ></app-kpi-card>
        <app-kpi-card
          title="Active Geofences"
          icon="pi pi-map"
          color="success"
          [value]="null"
          [loading]="true"
        ></app-kpi-card>
      </div>
    </div>
  }
  @if (isReady()) {
    <div>
      <div class="kpi-grid">
        <app-kpi-card
          title="Pending Healthy Gourmet Kitchens"
          icon="pi pi-users"
          color="primary"
          ctaLabel="View Healthy Gourmet Kitchens"
          ctaIcon="pi pi-eye"
          [value]="totalProducers()"
          (ctaClick)="navigateToPath(['producers'])"
        ></app-kpi-card>
        <app-kpi-card
          title="Active Healthy Gourmet Kitchens"
          icon="pi pi-clock"
          color="warning"
          ctaLabel="View Active Healthy Gourmet Kitchens"
          ctaIcon="pi pi-eye"
          [value]="totalOnboardedProducers()"
          (ctaClick)="navigateToActiveProducers()"
        ></app-kpi-card>
        <app-kpi-card
          title="Active Geofences"
          icon="pi pi-map"
          color="success"
          ctaLabel="View Geofences"
          ctaIcon="pi pi-eye"
          [value]="totalGeofences()"
          (ctaClick)="navigateToPath(['geofences'])"
        ></app-kpi-card>
      </div>
    </div>
  }
</div>
